import * as Bowser from 'bowser';

const { parse } = Bowser;
function getDeviceInfo() {
    return parse(window.navigator.userAgent);
}

export { getDeviceInfo };
//# sourceMappingURL=getDeviceInfo.js.map
